import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import { Logo } from "@storyworm/ssup-ui";

/**
 * Centered, branded frame for the signed-out screens (sign-in, MFA, loading):
 * the StoryWorm logo above a single constrained content card.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        p: 3,
      }}
    >
      <Logo maxWidth={200} />
      <Box sx={{ width: "100%", maxWidth: 420 }}>{children}</Box>
    </Box>
  );
}
